<template>
  <div v-loading="inputPageLoading" class="input-body"
    :class="screenStatus == 0 ? 'vertical-screen' : 'landscape-screen'">
    <div class="main-div">
      <div class="info-div" :style="{ width: mainItemDivWidth }">
        <div class="match-div">
          <span v-if="refereeInfo"> {{ refereeInfo.matchName }}</span>
        </div>
        <div class="referee-div">
          <div class="referee-info-item">
            <div class="title">裁判类型</div>
            <div class="value">
              <span v-if="refereeInfo">{{ refereeInfo.typeName }}</span>
            </div>
          </div>
          <div class="referee-info-item">
            <div class="title">裁判姓名</div>
            <div class="value">
              <span v-if="refereeInfo">{{ refereeInfo.name }}</span>
            </div>
          </div>
          <div class="referee-info-item">
            <div class="title">场地编号</div>
            <div class="value">
              <span v-if="refereeInfo">{{ refereeInfo.regionName ==
                'default' ? '' : refereeInfo.regionName }}{{
                  refereeInfo.groundNum }}号</span>
            </div>
          </div>
        </div>
        <div class="user-div">
          <div class="user-image-div">
            <img src="../../../assets/default-header-icon.png" alt="">
            <!-- <img v-if="userInfo && (!userInfo.AthletePhotoFilePaths || userInfo.AthletePhotoFilePaths.length==0)"
              src="../../../assets/default-header-icon.png" alt=""> -->
            <!-- <el-carousel height="50vh" v-if="userInfo && userInfo.AthletePhotoFilePaths != null">
              <el-carousel-item v-for="item in userInfo.AthletePhotoFilePaths" :key="item">
                <el-image :src="fileRootPath + item" :preview-src-list="[fileRootPath + item]">
                </el-image>
              </el-carousel-item>
            </el-carousel> -->


          </div>
          <div class="user-detail-div">
            <div class="title">项目名</div>
            <div class="value">
              <span v-if="userInfo">{{ userInfo.ProjectName }}</span>
            </div>
            <div class="title">项目类型</div>
            <div class="value">
              <span v-if="userInfo">{{ userInfo.ProjectTypeName }}</span>
            </div>
            <div class="title">运动员</div>
            <div class="value">
              <span v-if="userInfo">{{ userInfo.UserName }}</span>
            </div>
            <div class="title">性别</div>
            <div class="value">
              <span v-if="userInfo">{{ userInfo.GenderText }}</span>
            </div>
            <div class="title">单位/学校</div>
            <div class="value">
              <span v-if="userInfo">{{ userInfo.Unit }}</span>
            </div>
          </div>

        </div>

        <div v-if="userInfo && userInfo.Status === 1" style="text-align: right; margin: 1rem 5rem">

          <el-button type="primary" size="small"
          @click="readyBtnClick" v-if="
            userInfo &&
            userInfo.Status === 1 &&
            refereeInfo.jobs.indexOf('确认运动员到场') > -1
          " style="width: 5rem;">确认到场</el-button>
          <el-button type="danger" size="small"
          @click="setUserStatusBtnClick('弃权')" v-if="
            userInfo &&
            userInfo.Status === 1 &&
            refereeInfo.jobs.indexOf('设置弃权') > -1
          " style="width: 5rem;">弃 权</el-button>
        </div>

        <div style="position: absolute;left: 20px;bottom: 50px; width: 100px;">
          <div >
          <el-button size="mini" type="" icon="el-icon-refresh" @click="handleMenuCommand('refreshPage')">刷新</el-button>
          </div>
          <div style="margin-top: 5px;">
          <el-button size="mini" type="primary" icon="el-icon-setting" @click="handleMenuCommand('editReferee')">设置</el-button>
          </div>
          <div style="margin-top: 5px;">
          <el-button size="mini" type="danger" icon="el-icon-switch-button" @click="handleMenuCommand('logout')">退出</el-button>
          </div>
        </div>


      </div>
      <div class="score-div" :style="{ width: mainItemDivWidth }">

        <div class="score-group-div" v-if="userInfo && userInfo.Status === 2">
          <el-collapse v-model="scoreCollapseAct">
            <el-collapse-item name="扣分次数" v-if="refereeInfo.jobs.indexOf('扣分次数') > -1
            ">
              <template slot="title">
                <p class="collapse-title">扣分次数</p>
              </template>

              <div class="score-item-div marginTop-12">
                <div style="width: 23rem;margin: 0 auto;text-align: center;">
                  <custom-input-number :increaseItems="[-100, -10, -1]" :decreaseItems="[1, 10, 100]"
                    v-model="score.violationTimes" :min="0" :inputStype="{ width: '5rem' }"></custom-input-number>
                  <!-- <el-input-number v-model="score.violationTimes" :min="0" label="请输入次数"></el-input-number> -->
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="计次分数" v-if="
              refereeInfo.jobs.indexOf('计次') > -1 &&
              userInfo.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'
            ">
              <template slot="title">
                <p class="collapse-title">计次分数</p>
              </template>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('计次') > -1">
                <div style="width: 23rem;margin: 0 auto;text-align: center;">
                  <!-- <el-input-number v-model="score.times" :min="0" label="请输入次数"></el-input-number> -->
                  <custom-input-number :increaseItems="[-100, -10, -1]" :decreaseItems="[1, 10, 100]"
                    v-model="score.times" :min="0" :inputStype="{ width: '5rem' }" @change="syncScore"></custom-input-number>

                </div>
                <div style="text-align: center;margin-top: 10px;">
                  <el-button size="small" type="primary" @click="score.times = score.times * 2;syncScore()">分数*2</el-button>
                  <el-button size="small" type="primary" @click="score.times = score.times * 3;syncScore()">分数*3</el-button>
                </div>
                <div style="margin-top: 3rem;" v-if="refereeInfo.jobs.indexOf('计数按钮') > -1">

                  <el-button style="width: 14rem;
                    height: 14rem;border-radius: 50%;
                    font-size: 30px;outline: none;
                    " type="primary" click @click="clickCounter">计数+1</el-button>
                </div>
              </div>
            </el-collapse-item>
            <!-- 9个难度级别模式-->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="(
              (userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
              ) && refereeInfo.jobs.indexOf('难度分D') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">难度分（D）</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.d" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!--精英级个人花样、表演赛 DP DM DR难度-->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DP难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DP难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DP难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.dp" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DM难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DM难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DM难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.dm" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DR难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DR难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DR难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.dr" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!--精英级车轮跳花样Da Db-->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                && refereeInfo.jobs.indexOf('【精英级花样】DA难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DA难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DA难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.da" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                && refereeInfo.jobs.indexOf('【精英级花样】DB难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DB难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DB难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.db" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <!-- 精英级交互绳花样 Dj Dt -->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                && refereeInfo.jobs.indexOf('【精英级花样】DJ难度') > -1)
              || (userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DJ难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DJ难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.dj" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column label="分值" width="100" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.v.toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="
              (userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                && refereeInfo.jobs.indexOf('【精英级花样】DT难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DT难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DT难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.dt" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column label="分值" width="100" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.v.toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <!-- 一、二、三级难度模式 国内表演、国内花样 -->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="refereeInfo &&
              (userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                || userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095')
              && (refereeInfo.jobs.indexOf('【国内表演赛】一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内表演赛】二级难度') > -1
                || refereeInfo.jobs.indexOf('【国内表演赛】三级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】二级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】三级难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">难度分（D）</p>
              </template>
              <div class="score-item-div">
                <el-table border
                  :data="[score.c_d1, score.c_d2, score.c_d3].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!-- 只有一个难度级别模式 国内集体个人花样一级、二级-->
            <el-collapse-item name="难度分（D）" title="难度分（D）" v-if="refereeInfo &&
              (userInfo.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F' ||
                userInfo.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3')
              && (refereeInfo.jobs.indexOf('【国内集体个人花样】一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内集体个人花样】二级难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">难度分（D）</p>
              </template>
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'">

                <el-table border :data="[score.c_d1].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                <el-table border :data="[score.c_d2].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (refereeInfo && (userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')
                && refereeInfo.jobs.indexOf('重复难度U') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">重复难度（U）</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!--精英级个人花样 DP DM DR 重复难度-->
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DP难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DP难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DP重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_dp" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DM难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DM难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DM重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_dm" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】DR难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DR难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DR重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_dr" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!--精英级车轮跳花样Ua Ub-->
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                && refereeInfo.jobs.indexOf('【精英级花样】DA难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DA难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DA重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_da" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                && refereeInfo.jobs.indexOf('【精英级花样】DB难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DB难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DB重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_db" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!-- 精英级交互绳花样 UDT -->
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                && refereeInfo.jobs.indexOf('【精英级花样】DT难度/重复难度') > -1)
              || (userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                && refereeInfo.jobs.indexOf('【精英级表演赛】DT难度/重复难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">DT重复难度</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.u_dt" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column label="分值" width="100" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.v.toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!-- 国内表演、个人花样 -->
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="
              (userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                || userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095')
              && (refereeInfo.jobs.indexOf('【国内表演赛】重复一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内表演赛】重复二级难度') > -1
                || refereeInfo.jobs.indexOf('【国内表演赛】重复三级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】重复一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】重复二级难度') > -1
                || refereeInfo.jobs.indexOf('【国内花样赛】重复三级难度') > -1)

            ">
              <template slot="title">
                <p class="collapse-title">重复难度（U）</p>
              </template>
              <div class="score-item-div">
                <el-table border
                  :data="[score.c_u1, score.c_u2, score.c_u3].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!-- 只有一个难度级别模式 国内集体个人花样一级、二级-->
            <el-collapse-item name="重复难度（U）" title="重复难度（U）" v-if="refereeInfo &&
              (userInfo.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F' ||
                userInfo.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3')
              && (refereeInfo.jobs.indexOf('【国内集体个人花样】重复一级难度') > -1
                || refereeInfo.jobs.indexOf('【国内集体个人花样】重复二级难度') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">重复难度（U）</p>
              </template>
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'">

                <el-table border :data="[score.c_u1].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                <el-table border :data="[score.c_u2].filter(item => item.jobs.some(a => refereeInfo.jobs.includes(a)))"
                  class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="等级" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="创意编排分" v-if="(
              refereeInfo.jobs.indexOf('【规定赛】创意编排分') > -1
              && (userInfo.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                || userInfo.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                || userInfo.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'))
              || (refereeInfo.jobs.indexOf('【国内表演赛】创意编排分') > -1 &&
                userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')
              || (refereeInfo.jobs.indexOf('【国内花样赛】创意编排分') > -1 &&
                (userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                  || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                ))">
              <template slot="title">
                <p class="collapse-title">创意编排分</p>
              </template>
              <!-- 精英规定赛 -->
              <div class="score-item-div marginTop-12"
                v-if="userInfo.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
                <div style="width: 15rem;margin: 0 auto;text-align: center;">
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.t_ca" :min="0" :max="20"></custom-input-number>
                  <!-- <el-input-number v-model="score.t_ca" :min="0" :max="20" label="请输入分数"></el-input-number> -->
                </div>
              </div>

              <!-- 国内个人规定赛/国内集体规定赛 通用 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                || userInfo.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
                <el-table border :data="score.cr_ca" class="score-table-div" size="mini" style="max-width: 100%;"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="t" label="因素" width="190" align="center"></el-table-column>
                  <el-table-column prop="m" label="满分" width="80" align="center"></el-table-column>
                  <el-table-column label="得分" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" :max="scope.row.m" v-model="scope.row.s"
                        :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 国内表演赛 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                || userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'">
                <el-table border :data="score.c_ca" class="score-table-div" size="mini" style="max-width: 100%;"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="t" label="因素" width="100" align="center"></el-table-column>
                  <el-table-column prop="m" label="满分" width="100" align="center"></el-table-column>
                  <el-table-column label="得分" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" :max="scope.row.m" v-model="scope.row.s"
                        :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="完成质量分" title="完成质量分" v-if="(
              refereeInfo.jobs.indexOf('【规定赛】完成质量分') > -1
              && (userInfo.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                || userInfo.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                || userInfo.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
              )) || ((refereeInfo.jobs.indexOf('【国内表演赛】完成质量分') > -1)
                && userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')
              || (refereeInfo.jobs.indexOf('【国内花样赛】完成质量分') > -1 &&
                (userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                  || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                ))
            ">
              <template slot="title">
                <p class="collapse-title">完成质量分</p>
              </template>
              <!-- 精英规定赛 -->
              <div class="score-item-div marginTop-12"
                v-if="userInfo.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
                <div style="width: 23rem;margin: 0 auto;text-align: center;">
                  <!-- <el-input-number v-model="score.t_cq" :min="0" :max="80" label="请输入分数"></el-input-number> -->
                  <custom-input-number :increaseItems="[-50, -10, -1]" :decreaseItems="[1, 10, 50]" v-model="score.t_cq"
                    :inputStype="{ width: '5rem' }" :min="0" :max="80"></custom-input-number>
                </div>
              </div>

              <!-- 国内个人规定赛 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              ">
                <el-table border :data="score.cpr_cq" class="score-table-div" size="mini" style="max-width: 100%;"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="t" label="因素" width="190" align="center"></el-table-column>
                  <el-table-column prop="m" label="满分" width="80" align="center"></el-table-column>
                  <el-table-column label="得分" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" :max="scope.row.m" v-model="scope.row.s"
                        :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 国内团体规定赛 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
                <el-table border :data="score.ctr_cq" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="t" label="因素" width="190" align="center"></el-table-column>
                  <el-table-column prop="m" label="满分" width="80" align="center"></el-table-column>
                  <el-table-column label="得分" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" :max="scope.row.m" v-model="scope.row.s"
                        :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 国内表演赛 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                || userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'">
                <el-table border :data="score.c_cq" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类型" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="分值" width="100" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

            </el-collapse-item>
            <el-collapse-item name="表现分（P）" title="完成分（P）" v-if="
              (userInfo.ProjectTypeId ==
                '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userInfo.ProjectTypeId ==
                'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') &&
              (refereeInfo.jobs.indexOf('Pa动作技能') > -1 ||
                refereeInfo.jobs.indexOf('Pr娱乐编排') > -1 ||
                refereeInfo.jobs.indexOf('Pr音乐运用') > -1 ||
                (refereeInfo.jobs.indexOf('Fs形式风格') > -1 && userInfo.ProjectTypeId ==
                  'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'))
            ">
              <template slot="title">
                <p class="collapse-title">完成分（P）</p>
              </template>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('Pa动作技能') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  Pa动作技能</div>
                <el-table border :data="score.p.pa" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header" width="400px">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="v" label="分值" width="65" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('Pr娱乐编排') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  Pr娱乐编排</div>
                <el-table border :data="score.p.pre" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="v" label="分值" width="65" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('Pr音乐运用') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  Pr音乐运用</div>
                <el-table border :data="score.p.prm" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="v" label="分值" width="65" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('Fs形式风格') > -1 && userInfo.ProjectTypeId ==
                'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  Fs形式风格</div>
                <el-table border :data="score.p.fs" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="v" label="分值" width="65" align="center"></el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="表现分（P）" title="表现分（P）" v-if="
              ((userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                || userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                || userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
              ) && refereeInfo.jobs.indexOf('【精英级花样】表现P') > -1)
              ||
              (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                || userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                || userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                || userInfo.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                && refereeInfo.jobs.indexOf('【精英级表演赛】表现P') > -1)
            ">
              <template slot="title">
                <p class="collapse-title">表现分（P）</p>
              </template>
              <div class="score-item-div" style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  音乐</div>
                <el-table border :data="score.p2.m" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header" width="400px">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  完成质量</div>
                <el-table border :data="score.p2.cq" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  创意</div>
                <el-table border :data="score.p2.ca" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="score-item-div" style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  娱乐</div>
                <el-table border :data="score.p2.r" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="score-item-div" style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 12.6rem;line-height: 12.6rem;">
                  多样性/重复性</div>
                <el-table border :data="score.p2.v" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <!--精英级花样赛-->
            <el-collapse-item name="规定元素（Q）" title="规定元素（Q）" v-if="
              (userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                || userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
              ) &&
              (refereeInfo.jobs.indexOf('【精英级花样】规定元素：力量体操') > -1 ||
                refereeInfo.jobs.indexOf('【精英级花样】规定元素：多摇') > -1 ||
                refereeInfo.jobs.indexOf('【精英级花样】规定元素：绳子运用') > -1 ||
                refereeInfo.jobs.indexOf('【精英级花样】规定元素：互相配合') > -1
              )
            ">
              <template slot="title">
                <p class="collapse-title">规定元素（Q）</p>
              </template>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('【精英级花样】规定元素：力量体操') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 9.45rem;line-height: 9.45rem;">
                  力量体操</div>
                <el-table border :data="score.q2.p" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header" width="400px">
                  <el-table-column label="等级" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('【精英级花样】规定元素：多摇') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 9.45rem;line-height: 9.45rem;">
                  多摇</div>
                <el-table border :data="score.q2.m" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('【精英级花样】规定元素：绳子运用') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 9.45rem;line-height: 9.45rem;">
                  绳子运用</div>
                <el-table border :data="score.q2.r" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <!-- <el-input-number v-model="scope.row.t" :min="0" label="请输入次数"></el-input-number> -->
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="score-item-div" v-if="userInfo.ProjectTypeId != 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                && refereeInfo.jobs.indexOf('【精英级花样】规定元素：互相配合') > -1"
                style="position: relative; display: flex;width: 100%;margin: 0 auto;">
                <div
                  style="position: relative;border: 1px solid #EBEEF5; font-weight: 800; font-size: 1rem;width: 6rem;height: 9.45rem;line-height: 9.45rem;">
                  互相配合</div>
                <el-table border :data="score.q2.i" size="mini" class="score-table-div"
                  header-row-class-name="score-table-header">
                  <el-table-column label="等级" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="score-level-font-family">{{
                        scope.row.l
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="次数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <!--精英级表演赛 规定元素-->
            <el-collapse-item name="规定元素（Q）" title="规定元素（Q）" v-if="
              (userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                || userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                || userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                || userInfo.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
              )
              && refereeInfo.jobs.indexOf('【精英级表演赛】规定元素Q') > -1">
              <template slot="title">
                <p class="collapse-title">规定元素（Q）</p>
              </template>
              <div class="score-item-div">
                <el-table border :data="score.e_q" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类别" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="满分数" width="100" align="center"></el-table-column>
                  <el-table-column label="分数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-1]" :decreaseItems="[1]" :inputStype="{ width: '5rem' }"
                        v-model="scope.row.t" :min="0" :max="scope.row.v"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item name="规定元素（Q）" title="规定元素（Q）" v-if="
              ((userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')
                && refereeInfo.jobs.indexOf('规定Q') > -1)
              || (userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A' &&
                refereeInfo.jobs.indexOf('【国内表演赛】规定元素分') > -1)">
              <template slot="title">
                <p class="collapse-title">规定元素（Q）</p>
              </template>
              <!--花样赛-->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'">
                <el-table border :data="score.q" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类别" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="满分数" width="100" align="center"></el-table-column>
                  <el-table-column label="分数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                        :inputStype="{ width: '5rem' }" v-model="scope.row.t" :min="0"
                        :max="scope.row.v"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 集体自编赛 -->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'">
                <el-table border :data="score.c_q" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类别" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="满分数" width="100" align="center"></el-table-column>
                  <el-table-column label="分数" width="275" align="center">
                    <template slot-scope="scope">
                      <custom-input-number :increaseItems="[-1]" :decreaseItems="[1]" :inputStype="{ width: '5rem' }"
                        v-model="scope.row.t" :min="0" :max="scope.row.v"></custom-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!--国内表演赛-->
              <div class="score-item-div" v-if="userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'">
                <el-table border :data="score.c_q" class="score-table-div" size="mini"
                  header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类别" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="满分次数" width="100" align="center"></el-table-column>
                  <el-table-column label="分数" width="275" align="center">
                    <template slot-scope="scope">
                      <div style="text-align:center;display:inline-block">
                        <custom-input-number :increaseItems="[-1]" :decreaseItems="[1]" :inputStype="{ width: '5rem' }"
                          v-model="scope.row.t" :min="0" :max="scope.row.v"></custom-input-number>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <!--国内花样赛-->
            <el-collapse-item name="规定元素（Q）" title="规定元素（Q）" v-if="
              ((userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095')
                && refereeInfo.jobs.filter(item => item.indexOf('【国内花样赛】规定元素') > -1).length > 0)">

              <template slot="title">
                <p class="collapse-title">规定元素（Q）</p>
              </template>

              <div class="score-item-div">
                <el-table border :data="score.c_q2.filter(item => item.jobs.filter(job => refereeInfo.jobs.indexOf(job) > -1
                  && ('528D50AF-3268-45B7-A0B2-6C25D6759095' == userInfo.ProjectTypeId
                    || ('39E56A5E-CB75-4245-AA8C-C0553C6C4ADF' == userInfo.ProjectTypeId && job != '【国内花样赛】规定元素：互相配合'))
                ).length > 0)" class="score-table-div" size="mini" header-row-class-name="score-table-header">
                  <el-table-column prop="l" label="类别" width="100" align="center"></el-table-column>
                  <el-table-column prop="v" label="满分次数" width="100" align="center"></el-table-column>
                  <el-table-column label="分数" width="275" align="center">
                    <template slot-scope="scope">
                      <div style="text-align:center;display:inline-block">
                        <custom-input-number :increaseItems="[-1]" :decreaseItems="[1]" :inputStype="{ width: '5rem' }"
                          v-model="scope.row.t" :min="0" :max="scope.row.v"></custom-input-number>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item name="失误扣分（M）" title="失误扣分（M）" v-if="
              ((userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') &&
                (refereeInfo.jobs.indexOf('Pa失误') > -1 ||
                  refereeInfo.jobs.indexOf('Q失误') > -1 ||
                  refereeInfo.jobs.indexOf('Pa违例') > -1))
            ">
              <template slot="title">
                <p class="collapse-title">失误扣分（M）</p>
              </template>
              <div class="score-item-div"
                v-if="(userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                  || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') && refereeInfo.jobs.indexOf('Pa失误') > -1"
                style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">失误次数(Pa)</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_pa" :min="0"></custom-input-number>
                </div>
              </div>
              <div class="score-item-div"
                v-if="(userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                  || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') && refereeInfo.jobs.indexOf('Q失误') > -1"
                style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">失误次数(Q)</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_q" :min="0"></custom-input-number>
                </div>
              </div>
              <div class="score-item-div"
                v-if="(userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                  || userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') && refereeInfo.jobs.indexOf('Pa违例') > -1"
                style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">违例次数(Pa)</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_v" :min="0"></custom-input-number>
                </div>
              </div>
            </el-collapse-item>
            <!-- 精英级花样赛-->
            <el-collapse-item name="失误扣分（M）" title="失误扣分（M）" v-if="
              ((userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                || userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                || userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
              )
                && (refereeInfo.jobs.indexOf('【精英级花样】失误m') > -1 ||
                  refereeInfo.jobs.indexOf('【精英级花样】间歇b') > -1 ||
                  refereeInfo.jobs.indexOf('【精英级花样】违例v') > -1))
              ||
              ((userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                || userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                || userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                || userInfo.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
              )
                && (refereeInfo.jobs.indexOf('【精英级表演赛】失误m') > -1 ||
                  refereeInfo.jobs.indexOf('【精英级表演赛】间歇b') > -1 ||
                  refereeInfo.jobs.indexOf('【精英级表演赛】违例v') > -1))
            ">
              <template slot="title">
                <p class="collapse-title">失误扣分（M）</p>
              </template>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('【精英级花样】失误m') > -1
                || refereeInfo.jobs.indexOf('【精英级表演赛】失误m') > -1" style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">失误m</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_m" :min="0"></custom-input-number>
                </div>
              </div>
              <div class="score-item-div" v-if="(userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                || userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                || userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
              ) && refereeInfo.jobs.indexOf('【精英级花样】间歇b') > -1
                && userInfo.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'"
                style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">间歇b</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_b" :min="0"></custom-input-number>
                </div>
              </div>
              <div class="score-item-div" v-if="refereeInfo.jobs.indexOf('【精英级花样】违例v') > -1
                || refereeInfo.jobs.indexOf('【精英级表演赛】违例v') > -1" style="display: flex;width: 80%;margin: 0 auto;">
                <div style="width: 15rem;height: 3rem;line-height: 3rem;font-size: 1rem;">违例v</div>
                <div>
                  <custom-input-number :increaseItems="[-10, -1]" :decreaseItems="[1, 10]"
                    :inputStype="{ width: '5rem' }" v-model="score.m_v" :min="0"></custom-input-number>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="userinfo-loading-div" v-if="
          pushUserInfoStatus == 0 ||
          pushUserInfoStatus == 1 ||
          pushUserInfoStatus == -1
        ">
          <span v-if="pushUserInfoStatus == 1">收到后台推送运动员信息，获取运动员信息中...</span>
          <span v-if="pushUserInfoStatus == 0">待后台推送信息...</span><span
            style="color: green;cursor: pointer;text-decoration: underline;" @click="refreshPage">刷新</span>
          <span v-if="pushUserInfoStatus == -1" style="color: #f56c6c">获取运动员信息出错，运动员ID：{{ uid }}</span>
          <!-- <span v-if="pushUserInfoStatus == 4" style="color: #F56C6C;">运动员弃权</span> -->
        </div>

        <div class="userinfo-loading-div" v-if="
          pushUserInfoStatus == 2 &&
          userInfo &&
          userInfo.Status === 1 &&
          refereeInfo.type !== 'E40E431C-1E46-4043-9746-26437F876C50'
        ">
          <span>等待主裁确认中.....</span>
        </div>

        <div class="userinfo-loading-div" v-if="userInfo && pushUserInfoStatus == 2 && userInfo.Status === 4">
          <span style="color: #f56c6c">运动员已弃权</span>
        </div>
         <div class="userinfo-loading-div" v-if="userInfo && pushUserInfoStatus == 2 && userInfo.Status === 5">
          <span style="color: #f56c6c">运动员已违例</span>
        </div>
        <div class="userinfo-loading-div" v-if="userInfo && pushUserInfoStatus == 2 && userInfo.Status === 3">
          <span style="color: green">运动员比赛结束</span>
        </div>

        <div class="btn-div">
           <el-button type="warning" @click="setUserStatusBtnClick('违例')" v-if="
            userInfo &&
            userInfo.Status === 2 &&
            refereeInfo.jobs.indexOf('判定违例') > -1
          " style="width: 5rem;">违例</el-button>
          <el-button type="primary" v-if="isShowSubmitScore()" @click="commitScore"
            style="width: 8rem;">提交分数</el-button>
          <el-button type="danger" @click="showUserScoreDialog" v-if="
            userInfo &&
            userInfo.Status === 2 &&
            refereeInfo.jobs.indexOf('成绩确认') > -1
          " style="width: 8rem;">成绩确认</el-button>
         
        </div>
      </div>
    </div>

    <div class="menuBtn" v-if="false">
      <el-dropdown trigger="click" @command="handleMenuCommand">
        <el-button circle icon="el-icon-menu" style="font-size: 2rem;">
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="editReferee">更改裁判信息</el-dropdown-item>
          <el-dropdown-item command="refreshPage">刷新</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="密码验证" :visible.sync="oprPwdCheckDialogVisible" :show-close="false" :close-on-press-escape="false"
      :close-on-click-modal="false" width="350px">
      <el-input type="password" v-model="oprPwd" @keyup.enter="submitRefereeInfo" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitRefereeInfo">确 定</el-button>

        <el-button size="mini" @click="oprPwdCheckDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="裁判信息填写" class="adaptive" :visible.sync="refereeInputShow" :show-close="false" :fullscreen="true"
      :close-on-press-escape="false" :close-on-click-modal="false" v-loading="refereeFormLoading" width="95%">
      <el-form v-if="editRefereeInfo" :model="editRefereeInfo" ref="refereeInfo" :rules="rInfoRule" label-width="80px">
        <div style="position: relative;height: 100%; width: 90%;display: flex;flex-wrap: wrap;margin: 0 auto;">
          <div :style="{ width: refereeFormLeftWidth }">
            <el-form-item label="赛事" prop="matchId">
              <el-select v-model="editRefereeInfo.matchId" @change="matchInfoChange" placeholder="请选择当前赛事">
                <el-option :label="matchitem.MatchName" :key="matchitem.MatchId" :value="matchitem.MatchId"
                  v-for="matchitem in matchList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="region">
              <el-select v-model="editRefereeInfo.region" @change="regionChange" placeholder="请选择裁判类型">
                <el-option :label="ritem.RegionName" :key="ritem.RegionId" :value="ritem.RegionId"
                  v-for="ritem in regionList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="裁判名称" prop="name">
              <el-input v-model="editRefereeInfo.name" autocomplete="off" style="width: 220px;"
                placeholder="请输入裁判名称"></el-input>
            </el-form-item>
            <el-form-item label="裁判类型" prop="type">
              <el-select v-model="editRefereeInfo.type" @change="refereeTypeChange" placeholder="请选择裁判类型">
                <el-option :label="typeitem.RefereeTypeName" :key="typeitem.RefereeTypeId"
                  :value="typeitem.RefereeTypeId" v-for="typeitem in refereeTypeInfo"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场地编号" prop="groundNum">
              <el-input-number v-model="editRefereeInfo.groundNum" :min="1" label="请输入场地编号"></el-input-number>
            </el-form-item>
          </div>
          <div
            :style="{ width: refereeFormRightWidth, maxHeight: refereeFormRightHeight, overflow: 'hidden', overflowY: 'auto', position: 'relative' }">

            <div v-for="ts in jobTypes" style="margin:7px 20px;">
              <p style="margin: 10px 0;font-weight: 600; "> {{ ts.GroupName }}</p>
              <el-checkbox-group v-model="editRefereeInfo.jobs">
                <el-checkbox style="margin-bottom: 10px;" v-for="job in ts.Items" :label="job.value" :key="job.value">{{
                  job.label
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="commitRefereeInfo">确 定</el-button>
        <el-button @click="cleanRefereeInfo" size="mini">清 空</el-button>
        <el-button type="info" @click="refereeInputShow = false" size="mini">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="裁判评分状态" class="adaptive" :visible.sync="userScoreDialogVisible" :show-close="false"
      :close-on-press-escape="false" :close-on-click-modal="false" width="35rem">

      <div v-if="userScore" style="width: 90%;margin: 0 auto;">
        <el-table border :data="userScore" size="mini">
          <el-table-column prop="type" label="类型" width="150"></el-table-column>
          <el-table-column prop="referees" label="已评分裁判"></el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="" @click="refreshScore()">刷 新</el-button>
        <el-button size="mini" type="danger" @click="confirmScore()">确 认</el-button>
        <el-button size="mini" type="info" @click="userScoreDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AppServices from "../../../request-server/request-services/app-services";
import Common from "@/utils/utils-common.js";
import Url from '@/request-server/request-url';
import userScoreData from '@/data/user-socre.js';
import refereeJobTypes from '@/data/referee-job-types.js';

import { buildConnection } from '@/utils/signalr';

export default {
  data() {
    return {
      fileRootPath: '',
      screenStatus: 0,
      numTest: 0,
      mainItemDivWidth: '50%',
      refereeFormLeftWidth: '40%',
      refereeFormRightWidth: '60%',
      refereeFormRightHeight: window.innerHeight - 200 + 'px',
      menuDrawer: false,
      //裁判信息
      refereeInfo: {
        name: "",
        region: "",
        type: "",
        typeName: "",
        groundNum: 1,
        matchId: "",
        matchName: "",
        regionName: "",
        jobs: [],
      },
      editRefereeInfo: {
        name: "",
        region: "",
        type: "",
        typeName: "",
        groundNum: 1,
        matchId: "",
        matchName: "",
        regionName: "",
        jobs: [],
      },
      //裁判类型信息列表
      refereeTypeInfo: [],
      //裁判信息录入弹框显示标识
      refereeInputShow: false,
      inputPageLoading: true,
      refereeFormLoading: false,
      matchList: [],
      regionList: [],
      rInfoRule: {
        name: [{ required: true, message: "请输入裁判名称", trigger: "blur" }],
        region: [
          { required: true, message: "请选择比赛区域", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择裁判类型", trigger: "change" },
        ],
        groundNum: [
          { required: true, message: "请输入场地编号", trigger: "blur" },
        ],
        matchId: [{ required: true, message: "请选择赛事", trigger: "change" }],
      },
      jobTypes: refereeJobTypes.JobTypes,
      //推送运动员信息状态,0:未收到信息推送，1：收到信息推送，2：获取到运动信息，-1：获取运动员信息出错
      pushUserInfoStatus: 0,
      userInfo: null,
      scoreCollapseAct: ['扣分次数', '计次分数', '创意编排分', '完成质量分', '难度分（D）', '重复难度（U）', '完成分（P）', '表现分（P）', '规定元素（Q）', '失误扣分（M）'],
      score: {},
      userScoreDialogVisible: false,
      userScoreDialogVisible1: false,
      userScore: null,
      oprPwdCheckDialogVisible: false,
      oprPwd: "",
      speedMatchWorldRecord: 0,
      instantScoreInterval:null,
      connection: null,
      isConnected:false,
      newScore: 1,
      newScore2: 1
    };
  },
  mounted(){
     this.initSignalR();
  },
  beforeDestroy() {
    if (this.connection) {
      this.connection.off('ReceiveScoreUpdate');
      this.connection.stop();
    }
  },
  watch: {
    $route(to, from) {
      this.loadBaseInfo();
      this.getSpeedMatchWorldRecord();
      this.refereeFormLoading = true;
      this.$store
        .dispatch("setRefereeInfo", null)
        .then(() => {
          if (this.$store.state.referee.curRefereeInfo) {
            this.refereeInputShow = false;
            this.refereeInfo = this.$store.state.referee.curRefereeInfo;
          }
        })
        .finally(() => {
          this.refereeFormLoading = false;
        });
    },
  },
  methods: {

async initSignalR() {
      this.connection = buildConnection();

      // 监听分数更新事件
      this.connection.on('ReceiveScoreUpdate', (name, score) => {
        //this.$set(this.scores, athleteName, score);
      });

      //监听全量分数事件（刚连接时）
      this.connection.on('ReceiveAllScores', (allScores) => {
        //console.log(allScores);
      });

      try {
        await this.connection.start();
        this.isConnected = true;
        console.log('SignalR connected');
      } catch (err) {
        console.error('SignalR connection failed:', err);
        this.isConnected = false;
       console.log(err);
      }
    },

    async submitScore(){
      this.newScore += 1;
      if (this.isConnected) {
        await this.connection.invoke('SubmitScore', "张三", this.newScore);
      }
    },
    async syncScore(){
      console.log("syncScore",this.score)
      if (this.isConnected && this.userInfo.ProjectTypeId == "F679B7E4-F852-4A2A-BAF2-EC21BE923826") {
        let data = Common.copyObj(this.score);
          data.uid = this.userInfo.UserId;
          data.k1 = this.$store.state.referee.k1;
          data.jobs = this.refereeInfo.jobs;
          data.pt = this.userInfo.ProjectTypeId;
        console.log(data)
        await this.connection.invoke('SubmitScore', this.refereeInfo.region , data);
      }
    },
    initScore() {
      let json = JSON.stringify(userScoreData.ScoreModel)
      this.score = JSON.parse(json);
      console.log(this.score)
    },
    clickCounter() {
      if (!this.score.times) {
        this.score.times = 0;
      }
      this.score.times++;
      this.syncScore();
    },
    loadBaseInfo() {
      Promise.all([
        AppServices.SelectMatchList({
          PageIndex: 1,
          PageSize: 1000000,
          Where: {
            MatchStatus: "1",
          },
        }),
        AppServices.RefereeType(),
      ]).then((res) => {
        this.matchList = res[0].data.Data;
        this.refereeTypeInfo = res[1].data;
        this.inputPageLoading = false;
      });
    },
    submitRefereeInfo() {
      if (this.oprPwd == "") {
        this.$message.warning("请输入操作密码");
        return;
      }

      AppServices.CheckAppOprPwd({ pwd: this.oprPwd }).then((res) => {
        if (res.code == 0) {
          this.editRefereeClick();
          this.oprPwdCheckDialogVisible = false;
          this.oprPwd = "";
          
        }
      });
    },


    getSpeedMatchWorldRecord() {
      AppServices.GetSpeedMatchWorldRecord().then(res => {
        if (res.code == 0) {
          this.speedMatchWorldRecord = res.data;
        }
      })
    },
    commitRefereeInfo() {
      this.$refs["refereeInfo"].validate((valid) => {
        if (valid) {
          this.refereeFormLoading = true;
          this.refereeInfo = Common.copyObj(this.editRefereeInfo);
          this.$store
            .dispatch("setRefereeInfo", {
              refereeInfo: this.editRefereeInfo,
            })
            .then(() => {
              if (this.$store.state.referee.curRefereeInfo) {
                this.refereeInputShow = false;
                this.userInfo = null;
                this.pushUserInfoStatus = 0;
                this.refreshPage();
              }
            })
            .finally(() => {
              this.refereeFormLoading = false;
              this.editRefereeInfo = null;
            });
        }
      });
    },
    showOprPwdCheckDialog() {
      this.oprPwdCheckDialogVisible = true;
      this.oprPwd = "";
    },
    cleanRefereeInfo() {
      this.$confirm("确定要清空当前的裁判信息吗？", "提示", {
        customClass: 'confirm-custom-width',
        width: '300px'
      }).then(() => {
        this.editRefereeInfo = {
          name: "",
          region: "",
          type: "",
          typeName: "",
          groundNum: 1,
          matchId: "",
          matchName: "",
          regionName: "",
          jobs: [],
        };
        //this.$store.commit("cleanRefereeInfo");
      });
    },
    refereeTypeChange(data) {
      let i = this.refereeTypeInfo.find((res) => res.RefereeTypeId == data);
      if (i) {
        this.editRefereeInfo.typeName = i.RefereeTypeName;
        let jobStr = i.RefereeResponsibility;
        if (jobStr) {
          this.editRefereeInfo.jobs = jobStr.split(',')
        }
      }



    },
    regionChange(data) {
      let i = this.regionList.find((res) => res.RegionId == data);
      if (i) this.editRefereeInfo.regionName = i.RegionName;
    },
    matchInfoChange(data) {

      let i = this.matchList.find((res) => res.MatchId == data);
      this.regionList = [];
      this.editRefereeInfo.region = "";
      if (i) {
        this.editRefereeInfo.matchName = i.MatchName;
        this.regionList = i.Regions;
        if (this.regionList.length > 0) {
          this.editRefereeInfo.region = this.regionList[0].RegionId;
          this.regionChange(this.editRefereeInfo.region);
        }
      }
    },
    editRefereeClick() {
      this.editRefereeInfo = Common.copyObj(this.refereeInfo);
      this.refereeInputShow = true;
      if (this.editRefereeInfo.matchId) {
        let match = this.matchList.find(
          (a) => (a.MatchId == this.editRefereeInfo.matchId)
        );
        this.regionList = match.Regions;
      }

    },
    isShowSubmitScore() {
      if (this.userInfo == null) return false;
      if (this.userInfo && this.userInfo.Status === 2) {

        if (this.refereeInfo.jobs.indexOf('扣分次数') > -1) return true;
        //竞赛赛
        if (this.userInfo.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826') {
          return this.refereeInfo.jobs.indexOf('计次') > -1
        }
        //花样赛
        else if (this.userInfo.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D') {
          return (this.refereeInfo.jobs.indexOf('难度分D') > -1 ||
            this.refereeInfo.jobs.indexOf('重复难度U') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa动作技能') > -1 ||
            this.refereeInfo.jobs.indexOf('Pr娱乐编排') > -1 ||
            this.refereeInfo.jobs.indexOf('Pr音乐运用') > -1 ||
            this.refereeInfo.jobs.indexOf('规定Q') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa失误') > -1 ||
            this.refereeInfo.jobs.indexOf('Q失误') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa违例') > -1)

        }
        //集体自编
        else if (this.userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') {
          return (this.refereeInfo.jobs.indexOf('难度分D') > -1 ||
            this.refereeInfo.jobs.indexOf('重复难度U') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa动作技能') > -1 ||
            this.refereeInfo.jobs.indexOf('Pr娱乐编排') > -1 ||
            this.refereeInfo.jobs.indexOf('Pr音乐运用') > -1 ||
            this.refereeInfo.jobs.indexOf('Fs形式风格') > -1 ||
            this.refereeInfo.jobs.indexOf('规定Q') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa失误') > -1 ||
            this.refereeInfo.jobs.indexOf('Q失误') > -1 ||
            this.refereeInfo.jobs.indexOf('Pa违例') > -1)

        }
        //规定赛
        else if (this.userInfo.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
          || this.userInfo.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
          || this.userInfo.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
        ) {
          return (this.refereeInfo.jobs.indexOf('【规定赛】创意编排分') > -1 ||
            this.refereeInfo.jobs.indexOf('【规定赛】完成质量分') > -1
          );
        }
        //国内表演赛
        else if (this.userInfo.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A') {

          return (
            this.refereeInfo.jobs.indexOf('【国内表演赛】一级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】二级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】三级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】重复一级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】重复二级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】重复三级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】规定元素分') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】完成质量分') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内表演赛】创意编排分') > -1
          );

        }
        //【国内花样赛】个人跳，车轮跳，交互绳
        else if (this.userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
          || this.userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
        ) {
          return (this.refereeInfo.jobs.indexOf('【国内花样赛】一级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】二级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】三级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】重复一级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】重复二级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】重复三级难度') > -1 ||
            this.refereeInfo.jobs.filter(a => a.indexOf('【国内花样赛】规定元素') > -1).length > 0 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】完成质量分') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内花样赛】创意编排分') > -1);
        }
        //国内集体个人花样一级
        else if (this.userInfo.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F') {
          return (this.refereeInfo.jobs.indexOf('【国内集体个人花样】一级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内集体个人花样】重复一级难度') > -1)
        }
        //国内集体个人花样二级
        else if (this.userInfo.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3') {
          return (this.refereeInfo.jobs.indexOf('【国内集体个人花样】重复二级难度') > -1 ||
            this.refereeInfo.jobs.indexOf('【国内集体个人花样】重复二级难度') > -1)
        }
        //精英个人花样
        else if (this.userInfo.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8') {
          return (this.refereeInfo.jobs.indexOf('【精英级花样】DP难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】DM难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】DR难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】表现P') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：力量体操') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：多摇') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：绳子运用') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】失误m') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】间歇b') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】违例v') > -1
          )
        } else if (this.userInfo.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6') {
          return (this.refereeInfo.jobs.indexOf('【精英级花样】DA难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】DB难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】表现P') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：力量体操') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：多摇') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：绳子运用') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】规定元素：互相配合') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】失误m') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】间歇b') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】违例v') > -1
          )
        } else if (this.userInfo.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9') {
          return (this.refereeInfo.jobs.indexOf('【精英级花样】DJ难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】DT难度/重复难度') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】表现P') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】失误m') > -1
            || this.refereeInfo.jobs.indexOf('【精英级花样】违例v') > -1
          )
        }
        else if (this.userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || this.userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || this.userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
          || this.userInfo.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
          || this.userInfo.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
        ) {
          return this.refereeInfo.jobs.indexOf('【精英级表演赛】表现P') > -1
            || this.refereeInfo.jobs.indexOf('【精英级表演赛】规定元素Q') > -1
            || this.refereeInfo.jobs.indexOf('【精英级表演赛】失误m') > -1
            || this.refereeInfo.jobs.indexOf('【精英级表演赛】违例v') > -1
            || (this.userInfo.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
              && (this.refereeInfo.jobs.indexOf('【精英级表演赛】DP难度/重复难度') > -1 ||
                this.refereeInfo.jobs.indexOf('【精英级表演赛】DM难度/重复难度') > -1 ||
                this.refereeInfo.jobs.indexOf('【精英级表演赛】DR难度/重复难度') > -1))
            || (this.userInfo.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
              && (this.refereeInfo.jobs.indexOf('【精英级表演赛】DA难度/重复难度') > -1 ||
                this.refereeInfo.jobs.indexOf('【精英级表演赛】DB难度/重复难度') > -1))
            || (this.userInfo.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
              && (this.refereeInfo.jobs.indexOf('【精英级表演赛】DJ难度') > -1 ||
                this.refereeInfo.jobs.indexOf('【精英级表演赛】DT难度/重复难度') > -1));

        }
        else {
          return false;
        }
      } else {
        return false;
      }


    },
    commitScore() {
      let text = '是否确认提交评分？';
      if (this.userInfo.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'
        && this.speedMatchWorldRecord > 0 && this.score.times > this.speedMatchWorldRecord) {
        text = '您填写的计次分数已超过当前世界记录，是否确认提交评分？';
      }

      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = Common.copyObj(this.score);
          //国内个人花样规定元素不一样，赋值c_q后台统一接收
          if (this.userInfo.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
            || this.userInfo.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
          ) {
            data.c_q = data.c_q2;
          }
          else if (this.userInfo.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') {
            data.q = data.c_q;
          }

          data.uid = this.userInfo.UserId;
          data.k1 = this.$store.state.referee.k1;
          data.jobs = this.refereeInfo.jobs;
          data.pt = this.userInfo.ProjectTypeId;
          AppServices.SubmitScore(data).then((res) => {
            if (res.code == 0) {
               this.$message.success(res.data);
            }
          });
        })
        .catch(() => { });
    },

    resetUserInfo() {
      this.userInfo = null;

    },
    loadMatchUserInfo(uid) {
      this.pushUserInfoStatus = 0;
      if (!uid) return;
      AppServices.GetMatchUserInfo(uid).then((res) => {
        if (
          res.isError ||
          !res.data ||
          !res.data.UserName ||
          !res.data.ProjectName
        ) {
          this.pushUserInfoStatus = -1;
        } else {
          this.pushUserInfoStatus = 2;
          this.userInfo = res.data;
          this.initScore();

        }
      });
    },
    setUserStatusBtnClick(type) {
      this.$confirm(`确定当前运动员${type}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let status = type == '弃权' ? 4 : 5;
        AppServices.UpdateUserStatus(this.userInfo.UserId, status).then((res) => {
          if (res.data <= 0) this.$message.error("提交失败");
          this.loadMatchUserInfo(this.userInfo.UserId);
        });
      });
    },
    readyBtnClick() {
      AppServices.UpdateUserStatus(this.userInfo.UserId, 2).then((res) => {
        if (res.data <= 0) this.$message.error("准备提交失败");
        this.loadMatchUserInfo(this.userInfo.UserId);
      });
    },
    showUserScoreDialog() {
      this.userScore = null;
        this.refreshScore();
    },
    refreshScore() {
      AppServices.RefreshScore({ userId: this.userInfo.UserId }).then((res) => {
        if (res.code == 0) {
          //this.userScore = JSON.parse(res.data);
          this.userScore = this.handlerRefereeScoreData(JSON.parse(res.data));
          console.log(this.userScore);
          this.userScoreDialogVisible = true;
        }
      });
    },
    confirmScore() {
      // this.$confirm("是否确认运动员评分明细？确认后将无法再进行修改", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
        
      // });

      let data = {
          userId: this.userInfo.UserId,
          k2: this.$store.state.referee.k2,
          rName: this.refereeInfo.name,
        };
        AppServices.ConfirmScore(data).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.data);
            this.userScoreDialogVisible = false;
            this.userScore = null;
            this.loadMatchUserInfo(this.userInfo.UserId);
            this.initScore();
          }
        });
    },
    updateHtmlFontSize() {
      if (window.innerWidth < window.innerHeight) {
        this.mainItemDivWidth = "100%"
        this.refereeFormLeftWidth = '100%';
        this.refereeFormRightWidth = '100%';
        this.screenStatus = 0;
      } else {
        this.mainItemDivWidth = "50%"
        this.refereeFormLeftWidth = '40%';
        this.refereeFormRightWidth = '60%';
        this.screenStatus = 1;
      }

      window.onresize = () => {
        if (window.innerWidth < window.innerHeight) {
          this.mainItemDivWidth = "100%"
          this.refereeFormLeftWidth = '100%';
          this.refereeFormRightWidth = '100%';
          this.screenStatus = 0;
        } else {
          this.mainItemDivWidth = "50%";
          this.refereeFormLeftWidth = '40%';
          this.refereeFormRightWidth = '60%';
          this.screenStatus = 1;
        }

      }
    },

    handlerRefereeScoreData(score) {
      if (score == null) return [];
      let data = [];
      let projectTypeId = score.Project.ProjectTypeId;
      let deductPoint = { type: '扣分次数', referees: '' }
      if (score.DeductPointItems) {
        deductPoint.referees = score.DeductPointItems.map(a => a.referee.RefereeName + '(' + a.DeductPointCount + ')').join(',')
      }
      if (projectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826') {
        let time = { type: '次数', referees: '' }
        if (score.Times) {
          time.referees = score.Times.map(a => a.referee.RefereeName + '(' + a.Times + ')').join(',')
        }
        data = [deductPoint, time]
      } else if (projectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
        || projectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') {
        let d = { type: '难度分D', referees: '' }
        if (score.D_ScoreGroups) {
          d.referees = score.D_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u = { type: '重复难度U', referees: '' }
        if (score.D_ScoreGroups) {
          u.referees = score.U_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let pa = { type: 'Pa动作技能', referees: '' }
        if (score.Pa_ScoreGroups) {
          pa.referees = score.Pa_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let pre = { type: 'Pr娱乐编排', referees: '' }
        if (score.Pr_E_ScoreGroups) {
          pre.referees = score.Pr_E_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let prm = { type: 'Pr音乐运用', referees: '' }
        if (score.Pr_M_ScoreGroups) {
          prm.referees = score.Pr_M_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        data = [deductPoint, d, u, pa, pre, prm];

        if (projectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C') {
          let fs = { type: 'Fs形式风格', referees: '' }
          if (score.FS_ScoreGroups) {
            fs.referees = score.FS_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data.push(fs);
        }
        let q = { type: '规定Q', referees: '' }
        if (score.Q_ScoreGroups) {
          q.referees = score.Q_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        let mpa = { type: 'Pa失误', referees: '' }
        if (score.Mistake_Pa_ScoreGroups) {
          mpa.referees = score.Mistake_Pa_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        let mq = { type: 'Q失误', referees: '' }
        if (score.Mistake_Q_ScoreGroups) {
          mq.referees = score.Mistake_Q_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        let vpa = { type: 'Pa违例', referees: '' }
        if (score.V_ScoreGroups) {
          vpa.referees = score.V_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        data = [...data, ...[q, mpa, mq, vpa]];

      } else if (projectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
        || projectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
        || projectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
      ) {
        let ca = { type: '创意编排分', referees: '' }
        if (score.CreativeArrangementGroups) {
          ca.referees = score.CreativeArrangementGroups.map(a => a.referee.RefereeName).join(',')
        }

        let cq = { type: '完成质量分', referees: '' }
        if (score.CompletionQualityGroups) {
          cq.referees = score.CompletionQualityGroups.map(a => a.referee.RefereeName).join(',')
        }
        data = [deductPoint, ca, cq];
      } else if (projectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F') {
        let d = { type: '一级难度', referees: '' }
        if (score.D1_ScoreGroups) {
          d.referees = score.D1_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u = { type: '重复一级难度', referees: '' }
        if (score.U1_ScoreGroups) {
          u.referees = score.U1_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data = [deductPoint, d, u];
      } else if (projectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3') {
        let d = { type: '二级难度', referees: '' }
        if (score.D2_ScoreGroups) {
          d.referees = score.D2_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u = { type: '重复二级难度', referees: '' }
        if (score.U2_ScoreGroups) {
          u.referees = score.U2_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data = [deductPoint, d, u];
      } else if (projectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
        || projectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
        || projectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
      ) {
        let d1 = { type: '一级难度', referees: '' }
        if (score.D1_ScoreGroups) {
          d1.referees = score.D1_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let d2 = { type: '二级难度', referees: '' }
        if (score.D2_ScoreGroups) {
          d2.referees = score.D2_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let d3 = { type: '三级难度', referees: '' }
        if (score.D3_ScoreGroups) {
          d3.referees = score.D3_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u1 = { type: '重复一级难度', referees: '' }
        if (score.U1_ScoreGroups) {
          u1.referees = score.U1_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u2 = { type: '重复二级难度', referees: '' }
        if (score.U2_ScoreGroups) {
          u2.referees = score.U2_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let u3 = { type: '重复三级难度', referees: '' }
        if (score.U3_ScoreGroups) {
          u3.referees = score.U3_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        let ca = { type: '创意编排分', referees: '' }
        if (score.CA_ScoreGroups) {
          ca.referees = score.CA_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }

        let cq = { type: '完成质量分', referees: '' }
        if (score.CQ_ScoreGroups) {
          cq.referees = score.CQ_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        let q = { type: '规定元素分', referees: '' }
        if (score.Q_ScoreGroups) {
          q.referees = score.Q_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data = [deductPoint, d1, d2, d3, u1, u2, u3, ca, cq, q];
      } else if (
        projectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
        || projectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
        || projectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
      ) {
        if (projectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8') {
          let dp = { type: '难度Dp/重复难度', referees: '' }
          if (score.DP_ScoreGroups) {
            dp.referees = score.DP_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dm = { type: '难度Dm/重复难度', referees: '' }
          if (score.DM_ScoreGroups) {
            dm.referees = score.DM_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dr = { type: '难度Dr/重复难度', referees: '' }
          if (score.DR_ScoreGroups) {
            dr.referees = score.DR_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, dp, dm, dr];
        } else if (projectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6') {
          let da = { type: '难度Da/重复难度', referees: '' }
          if (score.DA_ScoreGroups) {
            da.referees = score.DA_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let db = { type: '难度Db/重复难度', referees: '' }
          if (score.DB_ScoreGroups) {
            db.referees = score.DB_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, da, db];
        } else if (projectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9') {
          let dj = { type: '难度Dj', referees: '' }
          if (score.DJ_ScoreGroups) {
            dj.referees = score.DJ_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dt = { type: 'DT难度/重复难度', referees: '' }
          if (score.DT_ScoreGroups) {
            dt.referees = score.DT_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, dj, dt];
        }

        let p = { type: '表现分', referees: '' }
        if (score.P_ScoreGroups) {
          p.referees = score.P_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(p);
        if (projectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9') {
          let qp = { type: '规定元素:力量体操', referees: '' }
          if (score.Q_P_ScoreGroups) {
            qp.referees = score.Q_P_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data.push(qp);

          let qm = { type: '规定元素:多摇', referees: '' }
          if (score.Q_M_ScoreGroups) {
            qm.referees = score.Q_M_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data.push(qm);

          let qr = { type: '规定元素:绳子运用', referees: '' }
          if (score.Q_R_ScoreGroups) {
            qr.referees = score.Q_R_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data.push(qr);

          if (projectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6') {
            let qi = { type: '规定元素:互相配合', referees: '' }
            if (score.Q_I_ScoreGroups) {
              qi.referees = score.Q_I_ScoreGroups.map(a => a.referee.RefereeName).join(',')
            }
            data.push(qi);
          }
        }

        //扣分M
        let m = { type: '失误m', referees: '' }
        if (score.M_M_ScoreGroups) {
          m.referees = score.M_M_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(m);
        if (projectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9') {
          let b = { type: '间歇b', referees: '' }
          if (score.M_B_ScoreGroups) {
            b.referees = score.M_B_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data.push(b);
        }

        let v = { type: '违例v', referees: '' }
        if (score.M_V_ScoreGroups) {
          v.referees = score.M_V_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(v);
      } else if (
        projectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
        || projectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
        || projectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
        || projectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
        || projectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
      ) {
        if (projectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761') {
          let dp = { type: '难度Dp/重复难度', referees: '' }
          if (score.DP_ScoreGroups) {
            dp.referees = score.DP_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dm = { type: '难度Dm/重复难度', referees: '' }
          if (score.DM_ScoreGroups) {
            dm.referees = score.DM_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dr = { type: '难度Dr/重复难度', referees: '' }
          if (score.DR_ScoreGroups) {
            dr.referees = score.DR_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, dp, dm, dr];
        } else if (projectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A') {
          let da = { type: '难度Da/重复难度', referees: '' }
          if (score.DA_ScoreGroups) {
            da.referees = score.DA_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let db = { type: '难度Db/重复难度', referees: '' }
          if (score.DB_ScoreGroups) {
            db.referees = score.DB_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, da, db];
        } else if (projectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD') {
          let dj = { type: '难度Dj', referees: '' }
          if (score.DJ_ScoreGroups) {
            dj.referees = score.DJ_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          let dt = { type: 'DT难度/重复难度', referees: '' }
          if (score.DT_ScoreGroups) {
            dt.referees = score.DT_ScoreGroups.map(a => a.referee.RefereeName).join(',')
          }
          data = [deductPoint, dj, dt];
        }

        let p = { type: '表现分', referees: '' }
        if (score.P_ScoreGroups) {
          p.referees = score.P_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(p);

        let q = { type: '规定元素', referees: '' }
        if (score.Q_ScoreGroups) {
          q.referees = score.Q_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(q);

        let m = { type: '失误m', referees: '' }
        if (score.M_M_ScoreGroups) {
          m.referees = score.M_M_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(m);

        let v = { type: '违例v', referees: '' }
        if (score.M_V_ScoreGroups) {
          v.referees = score.M_V_ScoreGroups.map(a => a.referee.RefereeName).join(',')
        }
        data.push(v);

      }
      return data;

    },
    refreshPage() {
      window.location.reload();
      //location.href = location.origin + '#/referee/inputrecord?t=' + Date.now();
    },
    handleMenuCommand(e) {
      if (e == 'editReferee') {
        this.showOprPwdCheckDialog();
      } else if (e == 'refreshPage') {
        this.refreshPage();
      } else if (e == 'logout') {
        this.$confirm("是否确定要退出登录", "提示", {
          customClass: 'confirm-custom-width',
          width: '300px'
        }).then(() => {
          this.$store.commit("loginout");
          this.$router.replace("/referee/login");
        });
      }
    },
    instantScore(){
      if(this.instantScoreInterval == null){
         this.instantScoreInterval = setInterval(() => {
        if(this.userInfo && this.userInfo.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'){
          let data = Common.copyObj(this.score);
          data.uid = this.userInfo.UserId;
          data.k1 = this.$store.state.referee.k1;
          data.jobs = this.refereeInfo.jobs;
          data.pt = this.userInfo.ProjectTypeId;
          
          AppServices.InstantScore(data).then((res) => {
            if (res.code == 0) {
              
            }
          });
        }
      }, 2000);
      }
    }
  },
  created() {
    this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/'
    this.updateHtmlFontSize();
    this.loadBaseInfo();
    this.getSpeedMatchWorldRecord();
    //this.instantScore();
    this.refereeFormLoading = true;
    this.$store
      .dispatch("setRefereeInfo", null)
      .then(() => {
        if (this.$store.state.referee.curRefereeInfo) {
          this.refereeInputShow = false;
          this.refereeInfo = this.$store.state.referee.curRefereeInfo;
        } else {
          this.oprPwd = '';
          this.oprPwdCheckDialogVisible = true;
        }
      })
      .finally(() => {
        this.refereeFormLoading = false;
      });

    this.loadMatchUserInfo(this.uid);
  },
  computed: {
    uid() {
      return this.$store.state.referee.uid;
    },
    userupdate() {
      return this.$store.state.referee.userupdate;
    },
  },
  watch: {
    uid(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal) {
          this.loadMatchUserInfo(newVal);

          this.initScore();

        } else {
          this.userInfo = null;
          this.pushUserInfoStatus = 0;
        }
      }
    },
    userupdate(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal && this.uid) {
          this.loadMatchUserInfo(this.uid);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.main-div {
  position: relative;
  overflow-y: auto;
  height: 100vh;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .info-div {
    position: relative;
    width: 40%;
    border-right: 1px solid rgb(217 216 216);
    box-sizing: border-box;

    .match-div {
      position: relative;
      font-size: 1.4rem;
      text-align: center;
      padding: 0.3rem 1.5rem;
      box-sizing: border-box;
      background-color: rgb(64, 158, 255);
      color: #fff;
      min-height: 2.8rem;
      font-weight: 600;
    }

    .referee-div {
      position: relative;
      display: flex;
      width: 98%;
      height: 4rem;
      margin: 0.5rem 1%;
      box-sizing: border-box;

      .referee-info-item:nth-of-type(1) {
        position: relative;
        width: 50%;
      }

      .referee-info-item {
        position: relative;
        width: 25%;
        text-align: center;
        height: 2rem;
        line-height: 2rem;
        background-color: #f3f3f3;

        .title {
          font-size: 1rem;
          font-weight: 600;
          border: 1px solid rgb(217 216 216);
        }

        .value {
          font-size: 1rem;
          border: 1px solid rgb(217 216 216);
        }
      }

    }

    .user-div {
      position: relative;
      display: flex;
      width: 98%;
      margin: 0.5rem 1%;
      background-color: #f3f3f3;
      border: 1px solid rgb(217 216 216);

      .user-image-div {
        position: relative;
        width: 45%;
        text-align: center;

        img {
          position: relative;
          width: 95%;
          object-fit: contain;
          margin: 2.5% auto;
        }
      }

      .user-detail-div {
        position: relative;
        width: 55%;

        .title {

          position: relative;
          font-size: 1rem;
          border: 1px solid rgb(217 216 216);
          width: 100%;
          height: 2rem;
          line-height: 2rem;
          background-color: #f3f3f3;
          padding-left: 1rem;
          box-sizing: border-box;
          font-weight: 600;
        }

        .value {
          min-height: 2rem;
          line-height: 2rem;
          padding: 0rem 1rem;
          box-sizing: border-box;
          border: 1px solid rgb(217 216 216);
          background-color: #fff;
          font-size: 1rem;
        }
      }
    }
  }

  .score-div {
    width: 60%;
    // height: 100vh;
    position: relative;

    .btn-div {
      position: absolute;
      bottom: 2rem;
      width: 100%;
      text-align: center;
    }

    .score-group-div {
      position: relative;
      height: calc(100vh - 6rem);
      width: 95%;
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      margin: 1rem auto;
    }
  }
}


.vertical-screen {
  .info-div {
    height: 0px !important;

  }

  .score-div {
    height: 0px !important;
  }

  .score-group-div {
    height: auto !important;
  }

  .btn-div {
    position: relative !important;
    margin: 3rem 0 !important;
    padding-bottom: 3rem !important;
  }

  .userinfo-loading-div {
    margin-top: 20% !important;
  }
}


.menuBtn {
  position: absolute;
  bottom: 30px;
  right: 50px;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 1.25rem;
  // background-color: #e3e3e3;
  line-height: 2.5rem;
  text-align: center;
  font-size: 1.5rem;
}



.input-body {
  overflow-y: auto;
  height: 100vh;
}



.userinfo-loading-div {
  text-align: center;
  color: #555555;
  font-size: 1.5rem;
  margin-top: 30%;
}

.score-item-div {
  text-align: center;

  >div {
    margin-bottom: 3px;
  }
}

.marginTop-12 {
  margin-top: 12px;
}

.score-group-div .el-input__inner {
  display: block;
  height: 2.6rem !important;
  font-size: 1.3rem !important;
}

.score-group-div .el-input-number__decrease,
.score-group-div .el-input-number__increase {
  height: 3.5rem !important;
  line-height: 3.5rem;
  font-size: 1.5rem;
}

.score-table-header {
  font-size: 1.3rem !important;
}

.score-table-header th {
  font-size: 1rem !important;
}

th {
  font-size: 1rem !important;
}

td {
  font-size: 1rem !important;
}

.score-table-div {
  width: auto;
  table-layout: auto;
  display: inline-block;
}

.noShow {
  display: none;
}

.score-level-font-family {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

::v-deep .adaptive {
  .el-dialog {
    @media screen and (max-width: 500px) {
      width: 95%;
    }
  }
}

.score-group-title {
  font-weight: 600;
  font-size: 18px;
  margin: 10px 0;
}

.score-item {
  min-height: 30px;
  line-height: 30px;
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
}

.collapse-title {
  font-size: 1.2rem;
  font-weight: 600;
}

::v-deep .el-descriptions-item__label {
  color: #000 !important;
  font-weight: 900 !important;
  font-size: 14px;
}

::v-deep .confirm-custom-width {
  width: 100px !important;
  /* 可以设置为你需要的任何宽度 */
}

.dialog-footer .el-button {
  width: 6rem;
}

.el-message-box {
  width: 350px !important;
}
</style>